import { Box, Paper, Typography } from "@mui/material";
import { BasePathProvider, useBasePath } from "components/Providers";
import EnrollmentPage from "./EnrollmentPage";
import LanguageToggle from "components/LanguageToggle";
import { useTranslation } from "react-i18next";

export default function EnrollmentIndex() {
  const baseUrl = useBasePath();
  const { t } = useTranslation();

  const renderSchoolLogos = () => (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
      <img
        src="https://ils.sfo2.digitaloceanspaces.com/var/www/html/2025/08/28135110/iLearn-Icon-Bergen-Alternate.jpg"
        alt="Bergen Icon"
        style={{ width: "52px" }}
      />
      <img
        src="https://ils.sfo2.digitaloceanspaces.com/var/www/html/2025/08/28135129/iLearn-Icon-Passaic-Alternate.jpg"
        alt="Passaic Icon"
        style={{ width: "52px" }}
      />
      <img
        src="https://ils.sfo2.digitaloceanspaces.com/var/www/html/2025/08/28135239/iLearn-Icon-Paterson-Alternate.jpg"
        alt="Paterson Icon"
        style={{ width: "52px" }}
      />
      <img
        src="https://ils.sfo2.digitaloceanspaces.com/var/www/html/2025/08/28135157/iLearn-Icon-Hudson-Alternate.png"
        alt="Hudson Icon"
        style={{ width: "52px" }}
      />
      <img
        src="https://ils.sfo2.digitaloceanspaces.com/var/www/html/2025/09/11112834/iLearn-Icon-Bronx-Alternate.png"
        alt="Bronx Icon"
        style={{ width: "52px" }}
      />
    </Box>
  );

  return (
    <BasePathProvider value={`${baseUrl}/applications`}>
      <Box width={'100%'} p={1}>
        <Box
          sx={{
            backgroundColor: "background.paper",
            borderRadius: 2,
            boxShadow: "1",
            p: 2,
            overflow: "auto",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography variant="h4" sx={{ fontWeight: 400 }}>
            {t('Enrollment Form')}
          </Typography>

          {renderSchoolLogos()}
        </Box>
        <EnrollmentPage />
        <Paper sx={{ position: 'fixed', right: 16, bottom: 16, zIndex: 1300 }}>
          <LanguageToggle />
        </Paper>
      </Box>
    </BasePathProvider>
  );
}
